import { render, staticRenderFns } from "./CustomerOverdueNumberDisplayer.vue?vue&type=template&id=4a3810a5"
import script from "./CustomerOverdueNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./CustomerOverdueNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports